// Get the iframe that posted the message
function getCalendlyIframeFromEvent(e: MessageEvent): HTMLIFrameElement | null {
    const iframes = Array.from(document.querySelectorAll('iframe[src*="calendly.com"]'));
    return iframes.find(f => (f as HTMLIFrameElement).contentWindow === e.source) as HTMLIFrameElement || null;
}

// Get the widget wrapper <div> (with .calendly-wrap) for a given iframe
function getWrapper(el: HTMLElement | null | undefined): HTMLElement | null {
    return el?.closest('.calendly-wrap') as HTMLElement || null;
}

// Generate and inject mobile tabs
function setupMobileTabs(): void {
    const calendlyItems = document.querySelectorAll('.calendly-wrap');
    if (calendlyItems.length === 0) return;
    
    // Create tabs container
    const tabsContainer = document.createElement('div');
    tabsContainer.className = 'affiliate-success-group__calendly-tabs';
    
    // Create tab buttons from calendly items and initialize visibility
    calendlyItems.forEach((item, index) => {
        const tabHeading = item.getAttribute('data-tab-heading') || `Option ${index + 1}`;
        const button = document.createElement('button');
        button.className = 'affiliate-success-group__calendly-tabs__button';
        button.textContent = tabHeading;
        button.setAttribute('data-index', index.toString());
        
        // First tab is active by default on mobile, others are hidden
        if (index === 0) {
            button.classList.add('active');
        } else {
            item.classList.add('mobile-hidden');
        }
        
        // Handle tab click
        button.addEventListener('click', (e) => {
            e.preventDefault();
            switchToTab(index);
        });
        
        tabsContainer.appendChild(button);
    });
    
    // Insert tabs before the columns
    const columnsContainer = document.querySelector('.affiliate-success-group__calendly-items__columns');
    if (columnsContainer && columnsContainer.parentElement) {
        columnsContainer.parentElement.insertBefore(tabsContainer, columnsContainer);
    }
}

// Switch active tab on mobile
function switchToTab(index: number): void {
    const calendlyItems = document.querySelectorAll('.calendly-wrap');
    const tabButtons = document.querySelectorAll('.affiliate-success-group__calendly-tabs__button');
    
    // Update calendly items visibility
    calendlyItems.forEach((item, i) => {
        item.classList.toggle('mobile-hidden', i !== index);
    });
    
    // Update tab button active state
    tabButtons.forEach((button, i) => {
        button.classList.toggle('active', i === index);
    });
}

// Enable/disable helpers
function disableExcept(wrapper: HTMLElement | null | undefined): void {
    if (!wrapper) return;
    
    // Hide all widgets except the active one
    document.querySelectorAll('.calendly-wrap').forEach(w => {
        w.classList.toggle('hidden', w !== wrapper);
    });
    
    // Hide the CTA area
    const ctaArea = document.querySelector('.affiliate-success-group__calendly-items__cta');
    if (ctaArea) {
        ctaArea.classList.add('hidden');
    }
    
    // Hide the mobile tabs
    const tabs = document.querySelector('.affiliate-success-group__calendly-tabs');
    if (tabs) {
        tabs.classList.add('hidden');
    }
    
    // Make the active calendar's parent column 100% width
    const activeColumn = wrapper.closest('.affiliate-success-group__calendly-items__column');
    if (activeColumn) {
        activeColumn.classList.add('active');
    }
}

function enableAll(): void {
    // Show all widgets
    document.querySelectorAll('.calendly-wrap').forEach(w => {
        w.classList.remove('hidden');
    });
    
    // Remove active class from all columns
    document.querySelectorAll('.affiliate-success-group__calendly-items__column').forEach(col => {
        col.classList.remove('active');
    });
    
    // Show the CTA area
    const ctaArea = document.querySelector('.affiliate-success-group__calendly-items__cta');
    if (ctaArea) {
        ctaArea.classList.remove('hidden');
    }
    
    // Show the mobile tabs
    const tabs = document.querySelector('.affiliate-success-group__calendly-tabs');
    if (tabs) {
        tabs.classList.remove('hidden');
    }
}

const CALENDLY_ORIGIN = "https://calendly.com";

function isCalendlyEvent(e: MessageEvent): boolean {
    return e.origin === CALENDLY_ORIGIN &&
        e.data && typeof e.data.event === "string" &&
        e.data.event.startsWith("calendly.");
}

// State: whichever widget the user is currently "scheduling" in
let activeWrapper: HTMLElement | null = null;

// Handle callback button click - show callback view
function setupCallbackButton() {
    const button = document.querySelector('.affiliate-success-group__calendly-items__button');
    const ctaLink = document.querySelector('.affiliate-success-group__calendly-items__cta a[href="#"]');
    if (!ctaLink) return;

    ctaLink.addEventListener('click', (e) => {
        e.preventDefault();
        
        const mainIntro = document.querySelector('.affiliate-success-group__intro');
        const calendlySection = document.querySelector('.affiliate-success-group__calendly-items');
        const callbackSection = document.querySelector('.affiliate-success-group__callback');
        
        if (calendlySection && callbackSection && mainIntro) {
            mainIntro.classList.add('hidden');
            calendlySection.classList.add('hidden');
            callbackSection.classList.add('visible');
        }

        // scroll to top of page
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
}

// Handle back button click - show Calendly view
function setupBackButton() {
    const backButton = document.querySelector('.affiliate-request-a-callback__button-back');
    if (!backButton) return;

    backButton.addEventListener('click', (e) => {
        e.preventDefault();
        
        const mainIntro = document.querySelector('.affiliate-success-group__intro');
        const calendlySection = document.querySelector('.affiliate-success-group__calendly-items');
        const callbackSection = document.querySelector('.affiliate-success-group__callback');
        
        if (calendlySection && callbackSection && mainIntro) {
            mainIntro.classList.remove('hidden');
            callbackSection.classList.remove('visible');
            calendlySection.classList.remove('hidden');
        }
    });
}

// Handle callback form submission
function setupCallbackFormSubmit() {
    const form = document.querySelector('.affiliate-request-a-callback-form');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        
        const formData = new FormData(form as HTMLFormElement);
        const phone = formData.get('phone') as string;
        const signupId = formData.get('signup_id') as string;
        
        if (!phone || !signupId) {
            alert('Phone number and signup ID are required.');
            return;
        }

        // Get Salesforce endpoint from data attribute
        const blockElement = document.querySelector('.wp-block-plaudit-affiliate-success-group');
        const salesforceEndpoint = blockElement?.getAttribute('data-salesforce-endpoint');
        
        if (!salesforceEndpoint) {
            console.error('Salesforce endpoint not found');
            alert('Configuration error: Salesforce endpoint not found. Please contact support.');
            return;
        }

        // Disable submit button during request
        const submitButton = form.querySelector('button[type="submit"]') as HTMLButtonElement;
        const originalText = submitButton?.textContent || 'Submit';
        if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = 'Submitting...';
        }

        try {
            const payload = {
                Phone: phone,
                SFObjectType: 'Signup',
                CallBack: 'true',
                SignupID: signupId
            };
            
            console.log('Sending to Salesforce:', payload);
            console.log('Using endpoint:', salesforceEndpoint);
            
            const response = await fetch(salesforceEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                // Success - you can customize this behavior
                const successMessage = document.querySelector('.affiliate-request-a-callback__success-message-group');
                const requestCallbackSection = document.querySelector('.affiliate-request-a-callback');
                if (successMessage && requestCallbackSection) {
                    successMessage.classList.add('visible');
                    requestCallbackSection.classList.add('hidden');
                }
            } else {
                throw new Error('Failed to submit callback request');
            }
        } catch (error) {
            console.error('Error submitting callback:', error);
            alert('There was an error submitting your callback request. Please try again.');
        } finally {
            // Re-enable submit button
            if (submitButton) {
                submitButton.disabled = false;
                submitButton.textContent = originalText;
            }
        }
    });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        setupMobileTabs();
        setupCallbackButton();
        setupBackButton();
        setupCallbackFormSubmit();
    });
} else {
    setupMobileTabs();
    setupCallbackButton();
    setupBackButton();
    setupCallbackFormSubmit();
}

window.addEventListener("message", (e: MessageEvent) => {
    if (!isCalendlyEvent(e)) return;

    const { event } = e.data;

    // Skip page_height events
    if (event === 'calendly.page_height') return;

    const srcIframe = getCalendlyIframeFromEvent(e);
    const wrapper = getWrapper(srcIframe);

    if (!wrapper) return;

    // User selected a date/time - disable the other widget
    if (event === "calendly.date_and_time_selected") {
        activeWrapper = wrapper;
        disableExcept(activeWrapper);
    }

    // User clicked "back" to return to calendar view
    // event_type_viewed fires on page load AND when clicking back
    // Only re-enable if there's an active wrapper (meaning user clicked back)
    if (event === "calendly.event_type_viewed" && activeWrapper !== null) {
        activeWrapper = null;
        enableAll();
    }

    // Booking finished — re-enable both widgets
    if (event === "calendly.event_scheduled") {
        activeWrapper = null;
        // TODO: Calendly shows a default message after booking, but do we want to redirect to a success page?
    }
});
